export default (() => {
  const forms = document.querySelectorAll('.contact-form')
  const grecaptcha = window.grecaptcha

  if (forms) {
    forms.forEach((form) => {
      form.addEventListener('submit', function (e) {
        // console.log(e)
        e.preventDefault()
        grecaptcha.ready(function() {
          grecaptcha.execute('6Ld5HRwrAAAAAAhKLsPHXkDWaN_r32LvJPOUJQ2h', {action: 'submit'}).then(function(token) {

            const csrfToken = form.querySelector("input[name='csrfToken']").value
            const button = form.querySelector('button')
            const formData = new FormData(form)

            button.disabled = true
            button.innerText = 'Sending...'

            function failedMessage() {
              e.target.innerHTML = `
                            <div class="rounded-5 d-inline-flex align-content-center align-items-center justify-content-center p-2 px-3 bg-body-secondary bg-opacity-25" style="backdrop-filter: blur(8px);" data-zanim-xs='{"animation": "slide-up" }'>
                                <i class="ci-alert-circle display-6 text-danger p-0 m-0"></i>
                                <p class="ms-2 mb-0 fs-sm fw-light">Failed to send your message. Please try again.</p>
                            </div>
                        `
            }

            let object = {};
            formData.forEach((value, key) => object[key] = value);
            const json = JSON.stringify(object);
            fetch('/msg', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Csrf-Token': csrfToken,
                'g-recaptcha-response': token
              },
              body: json
            }).then(response => {
              if (!response.ok) {
                console.error('something bad happened', response.status, response.statusText)
                failedMessage()
              } else {

                e.target.innerHTML = `
                            <div class="rounded-5 d-inline-flex align-content-center align-items-center justify-content-center p-2 px-3 bg-body-secondary bg-opacity-25" style="backdrop-filter: blur(8px);" data-zanim-xs='{"animation": "slide-up" }'>
                                <i class="ci-check-circle display-6 text-success p-0 m-0"></i>
                                <p class="ms-2 mb-0 fs-sm fw-light">We've received your message. We'll be in touch with you shortly.</p>
                            </div>
                        `
              }
            }).catch((error) => {
              console.error(error)
              failedMessage()
            })

          })
        })
      })
    })

  }

})()
